<template>
  <!-- 受付内容編集 -->
  <div id="HolterDetailEdit">
    <div id="container">
      <div class="labelTitle lable">ホルター心電図配送ｻｰﾋﾞｽ 受付内容編集</div>
      <div class="button-area">
        <b-button class="backButton is-primary" @click="back">戻る</b-button>
      </div>
      <div id="item-contens" v-if="isLoad">
        <div class="card-content margin-top">
          <span style="font-size: 20px">基本情報</span>
          <table>
            <tr><th>受付番号</th><td>{{targetNumber.join(',')}}<span v-if="commonItems.depo" class="depo"/></td></tr>
            <tr><th>医療機関名</th><td>{{commonItems.hospitalName}}</td></tr>
            <tr><th>医師名</th><td><input type="text" v-model="commonItems.doctorName" maxlength="105" :disabled="commonItems.isComp"/></td></tr>
            <tr><th>事務担当者名</th><td><input type="text"  v-model="commonItems.clerkName" maxlength="100" :disabled="commonItems.isComp"/></td></tr>
            <tr><th>機種</th>
		          <td>{{modelId  | getNameFilter(modelList) }}</td>
            </tr>
            <tr>
              <th>検査期間</th>
              <td>
                {{ inspectionPeriodLabel }}
              </td>
            </tr>
            <tr><th>解析オプション（有料）<span class="require"/></th>
              <td><select v-model="commonItems.analysisOption" name="解析オプション（有料）" @change="changedAnalysisOption" class="2" validate="required">
                <option v-for="analysisOption in analysisOptionList" :value="analysisOption.value" :key="analysisOption.value">{{ analysisOption.label1 }}</option>
                </select></td>
            </tr>
            <tr v-if="commonItems.judgmentFlag"><th>判定医</th><td><b-checkbox class="cstmCheckBox" v-model="commonItems.judgment">前回と違う判定医に依頼する。</b-checkbox></td></tr>
            <tr><th>機器配送先<span class="require"/></th><td>
              <div class="block">
                <b-radio class="td_radio" id="delivaryHome" v-model="commonItems.delivaryTarget" :disabled="data.length >= 2 || commonItems.isShipped || commonItems.depo" native-value="home">患者宅に配送する</b-radio>
                <b-radio class="td_radio" id="delivaryHospital" v-model="commonItems.delivaryTarget" :disabled="data.length >= 2 || commonItems.isShipped || commonItems.depo" native-value="hospital">医療機関に配送する</b-radio>
              </div></td>
            </tr>
            <tr v-if="commonItems.delivaryTarget== 'hospital' && !atLaunchHidden.hiddenFlag">
              <th>リードワイヤーアダプター<span class="require" name="item_step2" id="leadWireAdapter"/></th>
              <td>
                <div class="block">
                  <b-radio class="td_radio" name="リードワイヤーアダプター" v-model="commonItems.leadWireAdapter" :native-value="true">必要</b-radio>
                  <b-radio class="td_radio" name="リードワイヤーアダプター" v-model="commonItems.leadWireAdapter" :native-value="false">不要</b-radio>
                </div>
              </td>
            </tr>
            <template v-if="commonItems.delivaryTarget== 'hospital'">
              <tr><th>【機器配送先】</th>
              <tr>
                <th>郵便番号<span class="require"/></th>
                <td>
                  <input
                    :disabled="commonItems.isComp"
                    style="width: 270px;"
                    v-model="commonItems.hospitalPostcode"
                    class="edit"
                    :class="{'border-red': invalidShippingPostCode}"
                    name="機器配送先の郵便番号"
                    validate="required|numeric"
                    maxlength="7"
                    :placeholder="postcodePlaceholder"
                  />
                  <b-button
                    style="margin-left: 10px;
                    width: 150px;
                    height: 27px;"
                    v-on:click="addressSearch('device',commonItems.hospitalPostcode)"
                  >
                    郵便番号検索
                  </b-button>
                  <div v-if="invalidShippingPostCode" class="text-red">{{ invalidNumberMessage }}</div>
                </td>
              </tr>
              <tr><th>住所<span class="require"/></th><td><input :disabled="commonItems.isComp" type="text" v-model="commonItems.hospitalAddress" class="edit" name="機器配送先の住所" validate="required" maxlength="280"/></td></tr>
              <tr><th>住所（丁目、番地）<span class="require"/></th><td><input :disabled="commonItems.isComp" type="text" v-model="commonItems.hospitalHouseNumber" class="edit" name="機器配送先の住所（丁目、番地）" validate="required" maxlength="256"/></td></tr>
              <tr><th>住所（建物名、号室）</th><td><input :disabled="commonItems.isComp" type="text" v-model="commonItems.hospitalBuilding" maxlength="256"/></td></tr>
              <tr><th>宛名<span class="require"/></th><td><input :disabled="commonItems.isComp" type="text" v-model="commonItems.hospitalDestination" maxlength="100" class="edit" name="機器配送先の宛名" validate="required"/></td></tr>
              <tr>
                <th>連絡先(電話番号)<span class="require"/></th>
                <td>
                  <input
                    :disabled="commonItems.isComp"
                    type="text"
                    v-model="commonItems.hospitalPhoneNumber"
                    maxlength="11"
                    class="edit"
                    :class="{'border-red': invalidShippingPhoneNumber}"
                    name="機器配送先の連絡先(電話番号)"
                    validate="required|numeric"
                    :placeholder="phonePlaceholder"
                  />
                  <div v-if="invalidShippingPhoneNumber" class="text-red ">{{ invalidNumberMessage }}</div>
                </td>
              </tr>
              <tr><th>配達希望時間帯</th>
                <td v-if="!commonItems.isComp"><select v-model="commonItems.hospitalDesiredPickupTimeZone" ><option v-for="timeZone in desiredDeliveryTimeZoneList" :value="timeZone.value" :key="timeZone.value">{{ timeZone.label1 }}</option></select></td>
                <td v-else>{{commonItems.hospitalDesiredPickupTimeZone  | getNameFilter(desiredDeliveryTimeZoneList) }}</td>
              </tr>
            </template>
            <template v-if="!commonItems.depo">
              <template v-if="commonItems.createInternal">
                <tr><th>【結果送付先】</th></tr>
                <tr>
                  <th>郵便番号<span class="require"/></th>
                  <td>
                    <input
                      :disabled="commonItems.isComp"
                      style="width: 270px;"
                      v-model="commonItems.resultDeliveryPostcode"
                      maxlength="7"
                      class="edit"
                      :class="{'border-red': invalidDeliveryPostCode}"
                      name="結果送付先の郵便番号"
                      validate="required|numeric"
                      :placeholder="postcodePlaceholder"
                    />
                    <b-button
                      style="margin-left: 10px;
                      width: 150px;
                      height: 27px;"
                      v-on:click="addressSearch('result',commonItems.resultDeliveryPostcode)"
                    >
                      郵便番号検索
                    </b-button>
                    <div v-if="invalidDeliveryPostCode" class="text-red">{{ invalidNumberMessage }}</div>
                  </td>
                </tr>
                <tr><th>住所<span class="require"/></th><td><input :disabled="commonItems.isComp" type="text" v-model="commonItems.resultDeliveryAddress" maxlength="280" class="edit" name="結果送付先の住所" validate="required"/></td></tr>
                <tr><th>建物名</th><td><input :disabled="commonItems.isComp" type="text" v-model="commonItems.resultDeliveryBuilding" maxlength="256"/></td></tr>
                <tr><th>医療機関名(会社名)</th><td><input :disabled="commonItems.isComp" type="text" placeholder="宛名を個人宛にする場合、医療機関名(会社名）はこちらに入力してください。" v-model="commonItems.resultDeliveryHospital" maxlength="256"/></td></tr>
                <tr><th>診療科(部署名)</th><td><input :disabled="commonItems.isComp" type="text" placeholder="宛名を個人宛にする場合、診療科(部署名）はこちらに入力してください。" v-model="commonItems.resultDeliveryDepartment" maxlength="100"/></td></tr>
                <tr><th>宛名<span class="require"/></th><td><input :disabled="commonItems.isComp" type="text" placeholder="宛名に医療機関(会社名)を入れる場合、「医療機関名(会社名)」「診療科(部署名)」欄は空欄にしてください。" v-model="commonItems.resultDeliveryDestination" maxlength="100" class="edit" name="結果送付先の宛名" validate="required"/></td></tr>
                <tr>
                  <th>連絡先(電話番号)<span class="require"/></th>
                  <td>
                    <input
                      :disabled="commonItems.isComp"
                      type="text"
                      v-model="commonItems.resultDeliveryPhoneNumber"
                      maxlength="11"
                      class="edit"
                      :class="{'border-red': invalidDeliveryPhoneNumber}"
                      name="結果送付先の連絡先(電話番号)"
                      validate="required|numeric"
                      :placeholder="phonePlaceholder"
                    />
                    <div v-if="invalidDeliveryPhoneNumber" class="text-red">{{ invalidNumberMessage }}</div>
                  </td>
                </tr>
              </template>
              <tr><th class="deliverySlip_label">納品書</th><td>
                <div>
                  <b-radio class="td_radio deliverySlip_radio" v-model="commonItems.deliverySlip" :native-value="true" :disabled="commonItems.isComp">必要</b-radio>
                  <b-radio class="td_radio deliverySlip_radio" v-model="commonItems.deliverySlip" :native-value="false" :disabled="commonItems.isComp">不要</b-radio>
                </div>
              </td></tr>
              <tr><th>デモ</th><td><b-checkbox :disabled="commonItems.isComp" v-model="commonItems.demo" class="cstmCheckBox">デモ(トライアル)</b-checkbox></td></tr>
            </template>
          </table>
        </div>
        <template v-for="(patient, index) in data">
          <div class="card-content margin-top" :key="index">
            <span style="font-size: 20px">申込み内容{{index+1}}（受付番号：{{patient.receptionNo}}）</span>
            <div class="card-content margin-top">
              <span style="font-size: 20px">患者情報</span>
              <table>
                <tr>
                  <th>ステータス</th>
                  <td><span :class="getTabClass4RequestStatus(patient.status)" style="height:30px;margin-left:5px;width:20%;">{{getStatus(patient.status)}}</span>
                  </td>
                </tr>
                <template v-if="!(commonItems.depo && commonItems.isReadyOrDeposit)">
                  <tr><th>診察券ID（患者ID）<span class="require" /></th><td><input :disabled="patient.isComp" v-model="patient.patientId" type="text" maxlength="50" :class="'edit'+index" :name="index+1+'番目、診察券ID（患者ID）'"  validate="required"/></td></tr>
                      <tr><th>患者名<span class="require" /></th><td><input :disabled="patient.isComp" style="margin-right:5px; width:450px;" v-model="patient.patientFamilyName" type="text" placeholder="姓" maxlength="49" :class="'edit'+index" :name="index+1+'番目、患者名(姓)'" validate="required" /><input :disabled="patient.isComp" style="width:450px;" v-model="patient.patientFirstName" type="text" placeholder="名" maxlength="49" :class="'edit'+index" :name="index+1+'番目、患者名(名)'" validate="required"/></td></tr>
                      <tr><th>患者名（カナ）<span class="require" /></th><td><input :disabled="patient.isComp" style="margin-right:5px; width:450px;" v-model="patient.patientFamilyNameKana" type="text" placeholder="セイ" maxlength="49" :class="'edit'+index" :name="index+1+'番目、患者名カナ(セイ)'" validate="required|kana"/><input :disabled="patient.isComp" style="width:450px;" v-model="patient.patientFirstNameKana" type="text" placeholder="メイ" maxlength="49" :class="'edit'+index" :name="index+1+'番目、患者名カナ(メイ)'" validate="required|kana"/></td></tr>
                  <tr><th>性別<span class="require" /></th><td>
                    <div class="block">
                      <b-radio :disabled="patient.isComp" class="td_radio" size="is-small" v-model="patient.gender" native-value="-">-</b-radio>
                      <b-radio :disabled="patient.isComp" class="td_radio" size="is-small" v-model="patient.gender" native-value="男">男</b-radio>
                      <b-radio :disabled="patient.isComp" class="td_radio" size="is-small" v-model="patient.gender" native-value="女">女</b-radio>
                    </div></td>
                  </tr>
                  <tr><th>生年月日<span class="require" /></th><td><input :disabled="patient.isComp" v-model="patient.birthday" type="date" :input="inputBirthday(patient.birthday,index)" :class="'edit'+index" :name="index+1+'番目、患者の生年月日'" validate="required|date|birthDay" style="width:150px;height: 27px;" :max="yyyy_hyp_MM_hyp_dd(new Date())" /></td></tr>
                  <tr><th>年齢</th><td><input type="text" v-model="patient.age" disabled/></td></tr>
                  <tr><th>検査目的<span class="require"/></th>
                    <td>
                      <select v-model="commonItems.inspectionPurpose">
                        <option v-for="inspectionPurpose in inspectionPurposeList" :value="inspectionPurpose.value" :key="inspectionPurpose.value">{{ inspectionPurpose.label1 }}</option>
                      </select>
                    </td>
                  </tr>
                  <tr><th>基礎疾患・合併症<span v-if="commonItems.judgmentFlag" class="require"/></th><td><input type="text" v-model="commonItems.underlyingDisease" maxlength="256" :class="'edit'+index" :name="index+1+'番目、基礎疾患・合併症'" :validate="`${commonItems.judgmentFlag ? 'required' : ''}`"/></td></tr>
                  <tr><th>投薬状況<span v-if="commonItems.judgmentFlag" class="require"/></th><td><input type="text" v-model="commonItems.dosingStatus" maxlength="256" :class="'edit'+index" :name="index+1+'番目、投薬状況'" :validate="`${commonItems.judgmentFlag ? 'required' : ''}`"/></td></tr>
                  <tr><th>主訴<span v-if="commonItems.judgmentFlag" class="require"/></th><td><input type="text" v-model="commonItems.chiefComplaint" maxlength="256" :class="'edit'+index" :name="index+1+'番目、主訴'" :validate="`${commonItems.judgmentFlag ? 'required' : ''}`"/></td></tr>
                  <tr><th>ペースメーカー<span class="require"/></th>
                    <td>
                      <select v-model="commonItems.pacemaker" :class="'edit'+index" :name="index+1+'番目、患者のペースメーカー'" validate="required">
                        <option></option>
                        <option value="1">有り</option>
                        <option value="2">無し</option>
                      </select>
                    </td>
                  </tr>
                  <tr><th>次回受診日</th><td><input :disabled="patient.isComp" v-model="patient.nextDate" type="date" :class="'edit'+index" :name="index+1+'番目、患者の次回受診日'" validate="date" style="width:150px; height: 27px;"/></td></tr>
                  <template v-if="commonItems.delivaryTarget== 'home'">
                    <template v-if="!commonItems.depo">
                      <tr>
                        <th>郵便番号<span class="require"/></th>
                        <td>
                          <input
                            :disabled="patient.isComp"
                            type="text"
                            style="width: 270px;"
                            v-model="patient.postcode"
                            maxlength="7"
                            :class="['edit' + index, {'border-red': patient.invalidPatientPostCode}]"
                            :name="index+1+'番目、患者の郵便番号'"
                            validate="required|numeric"
                            :placeholder="postcodePlaceholder"
                          />
                          <b-button
                            style="margin-left:10px; width:150px; height:27px;"
                            v-on:click="patientAddressSearch(index,patient.postcode)"
                          >
                            郵便番号検索
                          </b-button>
                          <div v-if="patient.invalidPatientPostCode" class="text-red">{{ invalidNumberMessage }}</div>
                        </td>
                      </tr>
                      <tr><th>住所<span class="require"/></th><td><input :disabled="patient.isComp" type="text" v-model="patient.address" maxlength="256" :class="'edit'+index" :name="index+1+'番目、患者の住所'" validate="required"/></td></tr>
                      <tr><th>住所（丁目、番地）<span class="require"/></th><td><input :disabled="patient.isComp" type="text" v-model="patient.houseNumber" maxlength="256" :class="'edit'+index" :name="index+1+'番目、患者の住所（丁目、番地）'" validate="required"/></td></tr>
                      <tr><th>住所（建物名、号室）</th><td><input :disabled="patient.isComp" v-model="patient.building" type="text" maxlength="256"/></td></tr>
                      <tr><th>宛名<span class="require"/></th><td><input :disabled="patient.isComp" v-model="patient.destination" type="text" maxlength="100" :class="'edit'+index" :name="index+1+'番目、患者の宛名'" validate="required"/></td></tr>
                    </template>
                    <tr>
                      <th>連絡先（自宅または携帯）<span class="require" /></th>
                      <td>
                        <input
                          :disabled="patient.isComp"
                          type="text"
                          v-model="patient.phoneNumber"
                          maxlength="11"
                          :class="['edit' + index, {'border-red': patient.invalidPatientPhoneNumber}]"
                          :name="index+1+'番目、患者の連絡先（自宅または携帯）'"
                          validate="required|numeric"
                          :placeholder="phonePlaceholder"
                        />
                        <div v-if="patient.invalidPatientPhoneNumber" class="text-red">{{ invalidNumberMessage }}</div>
                      </td>
                    </tr>
                    <tr v-if="!commonItems.depo"><th>配達希望時間帯</th>
                      <td v-if="!patient.isComp"><select v-model="patient.desiredPickupTimeZone" ><option v-for="timeZone in desiredDeliveryTimeZoneList" :value="timeZone.value" :key="timeZone.value">{{ timeZone.label1 }}</option></select></td>
                      <td v-else>{{patient.desiredPickupTimeZone  | getNameFilter(desiredDeliveryTimeZoneList) }}</td>
                    </tr>
                  </template>
                  <tr>
                    <th style="vertical-align:top;">患者備考</th><td><textarea :disabled="patient.isComp" v-model="patient.patientNote" maxlength="256" style="resize:vertical;max-width:100%;height:100px;"></textarea></td>
                  </tr>
                </template>
                <b-modal :active.sync="cancelReasonInputModalActive" has-modal-card>
                  <reasonInputModal  v-on:setReason="reasonInput" v-bind:title="'検査キャンセル(キャンセル理由入力)'"></reasonInputModal>
                </b-modal>
              </table>
            </div>
            <div class="card-content margin-top">
              <span style="font-size: 20px">配送先情報</span>
              <table>
                <tr><th>出荷日<span class="require"/></th>
                  <td v-if="!patient.isShipped&&!patient.isComp"><input type="date" v-model="patient.desiredShippingDate" disabled style="width:150px; height: 27px;" validate="required"/><a @click="desiredShippingDateSelect(index)"><b-icon icon="calendar-cursor"></b-icon></a></td>
                  <td v-else>{{patient.desiredShippingDate | formatDate}}</td>
                </tr>
                <tr>
                  <th style="vertical-align:top;">配送先備考</th>
                  <td><textarea :disabled="patient.isComp" v-model="patient.deliveryInformationNote" maxlength="256" style="resize:vertical;max-width:100%;height:100px;"></textarea></td>
                </tr>
              </table>
            </div>
            <div class="card-content margin-top" v-if="patient.reception">
              <span style="font-size: 20px">受付情報</span>
              <table>
                <tr><th>シリアル</th><td>{{patient.serial}}
                  <b-button v-if="patient.serial && !patient.isShipped" style="margin-left:10px; width:150px; height:27px;" v-on:click="changeSerial(index, patient.serial, patient.receptionNo)">予約機器変更</b-button></td>
                </tr>
                <tr>
                  <th style="vertical-align:top;">受付備考</th><td><textarea :disabled="patient.isComp" v-model="patient.receptionNote" maxlength="256" style="resize:vertical;max-width:100%;height:100px;"></textarea></td>
                </tr>
              </table>
            </div>
            <div class="card-content margin-top" v-if="patient.isAnalysisOrder">
              <span style="font-size: 20px">解析依頼情報</span>
              <table>
                <tr>
                  <th style="vertical-align:top;">申送り事項</th><td><textarea :disabled="patient.isComp" v-model="patient.handoverInformation" maxlength="256" style="resize:vertical;max-width:100%;height:100px;"></textarea></td>
                </tr>
              </table>
            </div>
            <div class="button-area">
              <b-button v-if="!patient.isShipped" type="is-primary" @click="cancel(index)">検査をキャンセル</b-button>
            </div>
          </div>
        </template>
        <b-modal :active.sync="officeCalenderActive" has-modal-card>
          <officeCalenderModal :miniday="miniday" :maxDay="maxday" :disabledDays="disabledDays" @select="setShippingDate" @change-page="changePage"></officeCalenderModal>
        </b-modal>
        <b-modal :active.sync="isChangeDeviceModalActive" has-modal-card>
          <changeDeviceModal v-bind:oldSerialNumber="oldSerial" v-bind:model="modelId" v-bind:choicesType="choicesType.holterKind" v-bind:receptionNo="serialCahngeReceptionNo" v-bind:type="'HOLTER'" v-on:save="setNewSerial"></changeDeviceModal>
        </b-modal>
        <div v-if="commonItems.depo">
          ※本件と同医療機関を対象とする院内貸出案件の医師名、事務担当者、検査期間、機器配送先、出荷日がすべて更新されます。
        </div>
        <div class="button-area">
          <b-button type="is-primary" style="margin-left:12%;" @click="receptionist">更新</b-button>
          <b-button class="backButton is-primary" @click="back">戻る</b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  choicesType,
  analysisOption,
  requestStatus,
  invalidNumberMessage,
  postcodePlaceholder,
  phonePlaceholder,
} from "@/components/mock/base/const.js";
import reasonInputModal from "@/components/mock/philips/common/reasonInputModal";
import OfficeCalenderModal from "@/components/mock/guest/OfficeCalenderModal";
import ChangeDeviceModal from "@/components/mock/philips/common/ChangeDeviceModal";
import {atLaunchHidden} from "@/components/mock/base/const.js";

export default {
  name: "HolterDetailEdit",
  methods: {
    back: function() {
      this.$router.push({
        name: "HolterRequestContentChange",
        params: { searchConditions: this.searchParams },
      });
    },
    inputBirthday: function(birthday,index){
      var age = this.getAge(birthday)
      if(!isNaN(Number(age))){
        this.data[index].age = age < 0 ? 0 : age
      }else{
        this.data[index].age = ""
      }
    },
    receptionist: function() {
      // バリデーションチェック
      var elements = document.getElementsByClassName("edit")
      var result = this.selfMadeValidation(elements)
      var isError = result.isError
      var errorMsg = result.msg
      for(var i=0; i < this.data.length; i++){
        elements = document.getElementsByClassName("edit"+i)
        result = this.selfMadeValidation(elements)
        if(result.isError){
          isError = true
          errorMsg = errorMsg + result.msg
        }
      }
      if(isError){
        this.showErrorMessage(errorMsg)
        return
      }
      // this.updateTargetData = this.data[index]
      var excuteApi = this.setHolterReceptionContentsUpdatePOST;
      var successCallBack = this.setHolterReceptionContentsUpdatePOSTSuccess;
      var errorCallBack = this.setHolterReceptionContentsUpdatePOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    setHolterReceptionContentsUpdatePOST: function(client) {
      // var obj = JSON.parse(JSON.stringify(this.updateTargetData));
      var obj = JSON.parse(JSON.stringify(this.data))
      // obj.targetNumber = this.targetNumber
      var keys = Object.keys(this.commonItems)
      var isHospital = this.commonItems.delivaryTarget=="hospital"
      for(var i = 0; i < obj.length; i++){
        if(this.commonItems.depo && this.commonItems.isReadyOrDeposit){
          obj[i].age = "0";
        } else {
          obj[i].age = obj[i].age + ""
        }
        
        obj[i].model = this.modelId
        for(var j = 0; j < keys.length; j++){
          if(!isHospital){
            if(keys[j] == "postcode" || keys[j] == "address" ||
            keys[j] == "houseNumber" || keys[j] == "building" ||
            keys[j] == "destination" || keys[j] == "phoneNumber" ||
            keys[j] == "desiredPickupTimeZone"){
              continue;
            }
          }
          obj[i][keys[j]] = this.commonItems[keys[j]];
          
          if(this.commonItems.depo && this.commonItems.isReadyOrDeposit){
            if(keys[j] == "pacemaker" || keys[j] == "chiefComplaint" ||
            keys[j] == "dosingStatus" || keys[j] == "inspectionPurpose"){
              obj[i][keys[j]] = "";
            }
          }
        }
      }
      return client.apis.internalHolter.setHolterReceptionContentsUpdatePOST({
        body:obj
      });
    },
    setHolterReceptionContentsUpdatePOSTSuccess: function(result) {
      // メッセージ表示
      this.updateTargetData = {}
      this.showSuccess(result);
    },
    setHolterReceptionContentsUpdatePOSTError: function(result) {
      // エラーメッセージ表示
      this.updateTargetData = {}
      this.showErrorMessage(result);
    },
    cancel: function(index) {
      this.updateTargetData = this.data[index]
      this.cancelReasonInputModalActive = true
    },
    reasonInput: function(reason) {
      this.cancelReason = reason
      var excuteApi = this.setHolterReceptionInspectionCancelPOST;
      var successCallBack = this.setHolterReceptionInspectionCancelPOSTSuccess;
      var errorCallBack = this.setHolterReceptionInspectionCancelPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    setHolterReceptionInspectionCancelPOST: function(client) {
      return client.apis.internalHolter.setHolterReceptionInspectionCancelPOST({
        body:{
          receptionNo:this.updateTargetData.receptionNo,
          reason:this.cancelReason,
          version:this.updateTargetData.version
        }
      });
    },
    setHolterReceptionInspectionCancelPOSTSuccess: function(result) {
      // メッセージ表示
      if(this.data.length == 1){
        this.showSuccess(result,this.back());
        return
      }
      // this.data = this.data.filter(val => val.receptionNo != this.updateTargetData.receptionNo)
      this.updateTargetData = {}
      this.cancelReason = ""
      this.showSuccess(result);
      this.doSearch()
    },
    setHolterReceptionInspectionCancelPOSTError: function(result) {
      // エラーメッセージ表示
      this.updateTargetData = {}
      this.showErrorMessage(result);
    },
    deletePatient: function(index) {
      this.data.splice(index, 1);
    },
    doSearch: function() {
      var excuteApi = this.getHolterReceptionContentsDetailPOST;
      var successCallBack = this.getHolterReceptionContentsDetailPOSTSuccess;
      var errorCallBack = this.getHolterReceptionContentsDetailPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getHolterReceptionContentsDetailPOST: function(client) {
      return client.apis.internalHolter.getHolterReceptionContentsDetailPOST({
        body:{receiptNumber:this.targetNumber}
      });
    },
    getHolterReceptionContentsDetailPOSTSuccess: function(result) {
      // 検索結果取得
      this.data = result.obj
      var deviceReservation = this.data.find(val => val.isDeviceReservation)
      var isDeviceReservation = deviceReservation ?  true : false
      var completed = this.data.find(val => !val.isComp)
      var isComp = completed ? false : true
      this.commonItems = {
        hospitalName:this.data[0].hospitalName,
        doctorName : this.data[0].doctorName,
        clerkName : this.data[0].clerkName,
        delivaryTarget : this.data[0].delivaryTarget,
        hospitalPostcode : this.data[0].hospitalPostcode,
        hospitalAddress : this.data[0].hospitalAddress,
        hospitalHouseNumber : this.data[0].hospitalHouseNumber,
        hospitalBuilding : this.data[0].hospitalBuilding,
        hospitalDestination : this.data[0].hospitalDestination,
        hospitalPhoneNumber : this.data[0].hospitalPhoneNumber,
        hospitalDesiredPickupTimeZone : this.data[0].hospitalDesiredPickupTimeZone,
        postcode : this.data[0].postcode,
        address : this.data[0].address,
        houseNumber : this.data[0].houseNumber,
        building : this.data[0].building,
        destination : this.data[0].destination,
        phoneNumber : this.data[0].phoneNumber,
        desiredPickupTimeZone : this.data[0].desiredPickupTimeZone,
        resultDeliveryPostcode : this.data[0].resultDeliveryPostcode,
        resultDeliveryAddress : this.data[0].resultDeliveryAddress,
        resultDeliveryBuilding : this.data[0].resultDeliveryBuilding,
        resultDeliveryHospital : this.data[0].resultDeliveryHospital,
        resultDeliveryDepartment : this.data[0].resultDeliveryDepartment,
        resultDeliveryDestination : this.data[0].resultDeliveryDestination,
        resultDeliveryPhoneNumber : this.data[0].resultDeliveryPhoneNumber,
        deliverySlip : this.data[0].deliverySlip,
        delivaryTarget : this.data[0].delivaryTarget,
        demo : this.data[0].demo,
        isDeviceReservation:isDeviceReservation,
        isComp:isComp,
        createInternal:this.data[0].createInternal,
        underlyingDisease: this.data[0].underlyingDisease, // 使っている
        dosingStatus: this.data[0].dosingStatus, // 使っている
        chiefComplaint: this.data[0].chiefComplaint, // 使っている
        leadWireAdapter:this.data[0].leadWireAdapter, // 使っている
        inspectionPeriod: this.data[0].inspectionPeriod, // 使っている
        analysisOption: this.data[0].analysisOption, // 使っている
        inspectionPurpose: this.data[0].inspectionPurpose, // 使っている
        judgmentFlag: this.data[0].analysisOption=='2'?true:false,
        judgment: this.data[0].anotherjudgeDoctorFlag,
        pacemaker: this.data[0].pacemaker,
        depo: this.data[0].depo,
        isReadyOrDeposit: this.data[0].status == requestStatus.deviceReady || this.data[0].status == requestStatus.shippingReady || this.data[0].status == requestStatus.depositMachine ? true : false
      }
      this.isLoad = true;
      this.modelId = this.data[0].model;

      // 取得した検査期間の値から表示する検査期間のラベルを設定
      let targetInspectionPeriod = this.inspectionPeriodList.filter(data => { return data.value == this.commonItems.inspectionPeriod });
      this.inspectionPeriodLabel = targetInspectionPeriod[0].label1
    },
    getHolterReceptionContentsDetailPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result,this.back());
    },
    addressSearch: function(target,val){
      // 検索対象の郵便番号を設定
      this.searchTargetPostCode = val
      this.searchTargetAddress = null
      this.postCodeSearch().then(result=>{
        if (!this.searchTargetAddress) return; 
        if(target!="result"){
          this.commonItems.hospitalAddress = this.searchTargetAddress.prefecture + " " + this.searchTargetAddress.city + " " + this.searchTargetAddress.town
          this.commonItems.hospitalHouseNumber = ""
          this.commonItems.hospitalBuilding = ""
        }else{
          this.commonItems.resultDeliveryAddress = this.searchTargetAddress.prefecture + " " + this.searchTargetAddress.city + " " + this.searchTargetAddress.town
          this.commonItems.resultDeliveryBuilding = ""
        }
      })
    },
    patientAddressSearch: function(index,val){
      // 検索対象の郵便番号を設定
      this.searchTargetPostCode = val
      this.searchTargetAddress = null
      this.postCodeSearch().then(result=>{
        if (!this.searchTargetAddress) return; 
        this.data[index].address = this.searchTargetAddress.prefecture + " " + this.searchTargetAddress.city + " " + this.searchTargetAddress.town
        this.data[index].houseNumber = ""
        this.data[index].building = ""
        // 再レンダリングの為、フラグ切替
        this.renderKey = !this.renderKey
      })
    },
    postCodeSearch: function(){
      var excuteApi = this.getAddressFromPostCodePOST;
      var successCallBack = this.getAddressFromPostCodePOSTSuccess;
      var errorCallBack = this.getAddressFromPostCodePOSTError;
      // WebAPI Call
      return this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getAddressFromPostCodePOST: function(client) {
      return client.apis.apiCommon.getAddressFromPostCodePOST({
        body:{
          postCode:this.searchTargetPostCode
        }
      });
    },
    getAddressFromPostCodePOSTSuccess: function(result) {
      this.searchTargetAddress = result.obj
      this.searchTargetPostCode = ""
    },
    getAddressFromPostCodePOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
      this.searchTargetPostCode = ""
    },
    desiredShippingDateSelect: function(index){
      this.desiredShippingDateSelectIndex = index
      this.officeCalenderActive = true;
    },
    setShippingDate: function(selectDate){
      this.data[this.desiredShippingDateSelectIndex].desiredShippingDate = selectDate
      this.officeCalenderActive = false;
      this.desiredShippingDateSelectIndex = null
    },
    changePage: function(sDate, eDate) {
      var _this = this;
      this.apiCall(
        function(client){
          return client.apis.internalShipmentCalendar.getStockCalendarPOST({
            body: {
              startDate: sDate,
              endDate: eDate,
              modelId: _this.modelId,
              receptionNo: _this.targetNumber[0]
            }
          });
        },
        function(result){
          var disabled = result.obj.filter(data => {
            return data.stock < _this.targetNumber.length
          })
          _this.disabledDays = disabled
        },
        function(result){
          _this.showErrorMessage(result);
        }
      );
    },
    changeCommonItems: function(value, targetName) {
      for(var i = 0; i < this.data.length; i++){
        this.data[i][targetName] = value
      }
    },
    changeSerial: function(index, serial, receptionNo) {
      this.serialCahngeIndex = index
      this.serialCahngeReceptionNo = receptionNo
      this.oldSerial = serial
      this.isChangeDeviceModalActive = true
    },
    setNewSerial: function(newSerial) {
      this.data[this.serialCahngeIndex].serial = newSerial
      this.oldSerial = ""
      this.serialCahngeIndex = null
    },
    changedAnalysisOption: async function() {
      this.commonItems.judgmentFlag = this.commonItems.analysisOption == this.analysisOption.includedAll
    }
  },
  data() {
    var targetNumber = decodeURIComponent(this.$route.query["receiptNumber"])
    var receiptNumberList = decodeURIComponent(this.$route.query["receiptNumber"])
    if (!Array.isArray(targetNumber)) {
      targetNumber = targetNumber.split(",")
    }
    var receiptNumber = targetNumber[0];
    var searchParams = this.$route.params["searchConditions"];
    var cannulaSizeList = this.getChoiceList(choicesType.cannulaSize, false);
    var beltSizeList = this.getChoiceList(choicesType.beltSize, false);
    var attachedWaveformList =  this.getChoiceList(choicesType.attachedWaveform, false);
    var modelList = this.getChoiceList(choicesType.holterKind, false);
    let inspectionPurposeList = this.getChoiceList(choicesType.holterInspectionPurpose, false);
    let inspectionPeriodList = this.getChoiceList(choicesType.holterInspectionPeriod, false);
    let analysisOptionList = this.getChoiceList(choicesType.holterAnalysisOp, false);
    var desiredDeliveryTimeZoneList = this.getChoiceList(choicesType.deliveryTime, false);
    desiredDeliveryTimeZoneList.unshift({})
    var miniday = new Date(new Date().setHours(0, 0, 0, 0));
    var maxDate = new Date()
    maxDate.setDate(maxDate.getDate() + 365);
    var maxday = new Date(maxDate.getFullYear(), maxDate.getMonth(), maxDate.getDate());
    return {
      isLoad: false,
      data: [],
      commonItems:[],
      targetNumber,
      receiptNumber,
      searchParams,
      cannulaSizeList,
      beltSizeList,
      attachedWaveformList,
      searchTargetPostCode:"",
      searchTargetAddress:null,
      updateTargetData:{},
      cancelReasonInputModalActive:false,
      cancelReason:"",
      miniday,
      maxday,
      officeCalenderActive: false,
      disabledDays:[],
      modelId: null,
      modelList,
      desiredDeliveryTimeZoneList,
      receiptNumberList,
      serialCahngeIndex:null,
      serialCahngeReceptionNo:"",
      oldSerial:"",
      isChangeDeviceModalActive:false,
      choicesType,
      analysisOption:analysisOption, // 使っている
      inspectionPurposeList: inspectionPurposeList, // 使っている
      inspectionPeriodList: inspectionPeriodList, // 使っている
      analysisOptionList: analysisOptionList, // 使っている
      inspectionPeriodLabel: "",
      invalidShippingPostCode: false,
      invalidShippingPhoneNumber: false,
      invalidDeliveryPostCode: false,
      invalidDeliveryPhoneNumber: false,
      // template message
      invalidNumberMessage,
      postcodePlaceholder,
      phonePlaceholder,
      atLaunchHidden: atLaunchHidden
    };
  },
  async mounted() {
    // 詳細情報取得
    await this.doSearch();
  },
  filters: {
    formatDate: function(val){
      if(!val) return ""
      return val.replace(/-/g, "/")
    },
    getNameFilter: function(val, list){
      var target = list.find(item => item.value == val)
      if(target){
        return target.label1
      }
      return ""
    }
  },
  components: {
    reasonInputModal:reasonInputModal,
    officeCalenderModal:OfficeCalenderModal,
    changeDeviceModal:ChangeDeviceModal
  },
  watch: {
    "commonItems.hospitalPostcode"(newValue) {
      this.invalidShippingPostCode = isNaN(Number(newValue));
    },
    "commonItems.hospitalPhoneNumber"(newValue) {
      this.invalidShippingPhoneNumber = isNaN(Number(newValue));
    },
    "commonItems.resultDeliveryPostcode"(newValue) {
      this.invalidDeliveryPostCode = isNaN(Number(newValue));
    },
    "commonItems.resultDeliveryPhoneNumber"(newValue) {
      this.invalidDeliveryPhoneNumber = isNaN(Number(newValue));
    },
    "data": {
      handler(newValue) {
        newValue.map((value) => {
          value.invalidPatientPostCode = isNaN(Number(value.postcode));
          value.invalidPatientPhoneNumber = isNaN(Number(value.phoneNumber));
        });
      },
      deep: true,
    },
  },
};
</script>
<style lang="scss" scoped>
a {
  text-decoration: underline;
}

</style>



// WEBPACK FOOTER //
// src/components/mock/philips/holter/HolterDetailEdit.vue